import React from 'react'
import st from './ProfileAvatar.module.scss'
import { colors } from 'components/ContentBox/Global/ContentTable_test/avatar'
import Stores from 'Stores'

const ProfileAvatar = ({
  avatar,
  name,
  width = '42px',
  height = '42px',
  radius = '50%',
  fs = '16px',
}) => {
  const [firstName, lastName] = name ? name.split(' ') : []

  return (
    <>
      {avatar ? (
        <div
          className={st.avatarContent}
          style={{ width, height, borderRadius: radius }}
        >
          <img src={avatar} alt='avatar' />
        </div>
      ) : (
        <div
          className={st.nameAvatar}
          style={{
            backgroundColor:
              firstName && lastName
                ? colors(firstName + lastName)
                : name
                  ? colors(name[0])
                  : '',
            width,
            height,
            borderRadius: radius,
            fontSize: fs,
            minWidth: width,
            minHeight: height,
          }}
        >
          <div>
            {firstName && lastName
              ? Stores.transliterate(
                  firstName[0].toUpperCase() + lastName[0].toUpperCase(),
                )
              : name
                ? name[0].toUpperCase()
                : ''}
          </div>
        </div>
      )}
    </>
  )
}

export default ProfileAvatar
